import { FC } from 'react';
import { Box, Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SCUIGeneralDrawerHeader } from '../../../atomic/molecules';
import { SCS } from '../storeCustomerService.classes';

interface IProps {
    selectedRow?: any;
    onCloseMenu?: any;
}

export const SCUICustomerDrawerContent: FC<IProps> = ({ selectedRow, onCloseMenu }) => {
    const { t } = useTranslation();

    return (
        <Grid container sx={{ paddingTop: '2rem' }} className={SCS.detail}>
            <Box className={SCS.detailHeader}>
                <SCUIGeneralDrawerHeader header={t('general.detail')} onClose={onCloseMenu} />
            </Box>
            <Grid
                className={`${SCS.detailItem} ${SCS.detailItemStoreCode}`}
                data-store-code={selectedRow?.magazaKod}
                size={{
                    md: 12,
                    xs: 12,
                }}
            >
                <div className="txt-detail">
                    <b>{'Mağaza Kod'}: </b> {selectedRow?.magazaKod}
                </div>
            </Grid>
            <Grid
                className={`${SCS.detailItem} ${SCS.detailItemStoreName}`}
                data-store-name={selectedRow?.magazaAd}
                size={{
                    md: 12,
                    xs: 12,
                }}
            >
                <div className="txt-detail">
                    <b>{'Mağaza Ad'}: </b> {selectedRow?.magazaAd}
                </div>
            </Grid>
            <Grid
                className={`${SCS.detailItem} ${SCS.detailItemReturnId}`}
                data-return-id={selectedRow?.iadeKayitNo}
                size={{
                    md: 12,
                    xs: 12,
                }}
            >
                <div className="txt-detail">
                    <b>{'İade Kayıt No'}: </b> {selectedRow?.iadeKayitNo}
                </div>
            </Grid>
            <Grid
                className={`${SCS.detailItem} ${SCS.detailItemDate}`}
                data-date={selectedRow?.tarih}
                size={{
                    md: 12,
                    xs: 12,
                }}
            >
                <div className="txt-detail">
                    <b>{'Tarih'}: </b> {selectedRow?.tarih}
                </div>
            </Grid>
            <Grid
                className={`${SCS.detailItem} ${SCS.detailItemComplaint}`}
                data-complaint={selectedRow?.iadeSikayetKonusu}
                size={{
                    md: 12,
                    xs: 12,
                }}
            >
                <div className="txt-detail">
                    <b>{'İade Şikayet Konusu'}: </b> {selectedRow?.iadeSikayetKonusu}
                </div>
            </Grid>
            <Grid
                className={`${SCS.detailItem} ${SCS.detailItemCustomerNo}`}
                data-customer-no={selectedRow?.musteriNo}
                size={{
                    md: 12,
                    xs: 12,
                }}
            >
                <div className="txt-detail">
                    <b>{'Müşteri No'}: </b> {selectedRow?.musteriNo}
                </div>
            </Grid>
            <Grid
                className={`${SCS.detailItem} ${SCS.detailItemWarehouse}`}
                data-warehouse={selectedRow?.musteriDepo}
                size={{
                    md: 12,
                    xs: 12,
                }}
            >
                <div className="txt-detail">
                    <b>{'Müşteri Depo'}: </b> {selectedRow?.musteriDepo}
                </div>
            </Grid>
            <Grid
                className={`${SCS.detailItem} ${SCS.detailItemFullName}`}
                data-full-name={selectedRow?.ad}
                size={{
                    md: 12,
                    xs: 12,
                }}
            >
                <div className="txt-detail">
                    <b>{'Ad Soyad'}: </b> {selectedRow?.ad}
                </div>
            </Grid>
            <Grid
                className={`${SCS.detailItem} ${SCS.detailItemPhone}`}
                data-phone={selectedRow?.cepTel}
                size={{
                    md: 12,
                    xs: 12,
                }}
            >
                <div className="txt-detail">
                    <b>{'Cep numarası'}: </b> {selectedRow?.cepTel}
                </div>
            </Grid>
            <Grid
                className={`${SCS.detailItem} ${SCS.detailItemCounty}`}
                data-county={selectedRow?.ilce}
                size={{
                    md: 12,
                    xs: 12,
                }}
            >
                <div className="txt-detail">
                    <b>{'İlçe'}: </b> {selectedRow?.ilce}
                </div>
            </Grid>
            <Grid
                className={`${SCS.detailItem} ${SCS.detailItemCity}`}
                data-city={selectedRow?.il}
                size={{
                    md: 12,
                    xs: 12,
                }}
            >
                <div className="txt-detail">
                    <b>{t('general.cityName')}: </b> {selectedRow?.il}
                </div>
            </Grid>
            <Grid
                className={`${SCS.detailItem} ${SCS.detailItemStatus}`}
                data-status={selectedRow?.durum}
                size={{
                    md: 12,
                    xs: 12,
                }}
            >
                <div className="txt-detail">
                    <b>{'Durum'}: </b> {selectedRow?.durum}
                </div>
            </Grid>
        </Grid>
    );
};
